module.exports = __webpack_public_path__ + "img/zhaobi.7696d0cd.png";